import { ScrollStatus } from '../constants.js';

function neverDefault(keysKey) {
  throw new Error(`Unhandled case ${keysKey}`);
}
function anyUndefined(...input) {
  return input.some((value) => value === void 0);
}
function stopPropagation(e) {
  e.stopPropagation();
}
function getScrollStatusVertical({
  scrollTop,
  clientHeight,
  scrollHeight
}) {
  if (clientHeight >= scrollHeight) {
    return ScrollStatus.NoScroll;
  } else if (scrollTop) {
    if (scrollTop + clientHeight >= scrollHeight) {
      return ScrollStatus.Bottom;
    } else {
      return ScrollStatus.Scrolled;
    }
  } else {
    return ScrollStatus.Top;
  }
}
function findLast(arr, predicate) {
  for (let i = arr.length - 1; i >= 0; i--) {
    if (predicate(arr[i])) {
      return arr[i];
    }
  }
  return void 0;
}
const warnOnceWarnings = {};
function warnOnce(msg) {
  const isDevOrTest = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
  if (isDevOrTest && Boolean(msg) && !warnOnceWarnings[msg]) {
    warnOnceWarnings[msg] = true;
    console.warn(`@vaisala/rockhopper-components:
${msg}`);
  }
}
function printDevError(msg) {
  if (process.env.NODE_ENV === "development") {
    console.error(`@vaisala/rockhopper-components:
${msg}`);
  }
}
function scan(callback, acc) {
  return function scanner(next) {
    acc = callback(acc, next);
    return acc;
  };
}
function filterKeys(obj, keys) {
  return Object.keys(obj).filter((k) => !keys.includes(k)).map((k) => Object.assign({}, { [k]: obj[k] })).reduce((res, o) => Object.assign(res, o), {});
}
function wrapEventHandlers(libraryHandler, userHandler) {
  return (event) => {
    userHandler && userHandler(event);
    if (!event.defaultPrevented) {
      return libraryHandler(event);
    }
  };
}
function callVoids(...functions) {
  return function() {
    functions.filter((fn) => fn instanceof Function).forEach((fn) => fn());
  };
}
function getKeyboardFocusableElements(element = document) {
  const elementQueryPattern = 'a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])';
  if (element) {
    let interactiveElements = Array.from(element.querySelectorAll(elementQueryPattern));
    interactiveElements = interactiveElements.filter((el) => !el.hasAttribute("disabled"));
    return interactiveElements;
  } else {
    return null;
  }
}
function findLastIndex(array, predicate, startingIndex) {
  if (startingIndex) {
    if (startingIndex > array.length) {
      throw RangeError("startingIndex is larger than list length");
    }
    if (startingIndex < 0) {
      throw RangeError("startingIndex must be a positive number");
    }
  }
  let i = startingIndex ?? array.length;
  while (i--) {
    if (predicate(array[i], i, array)) {
      return i;
    }
  }
  return -1;
}
function containsNumericValue(cssStr) {
  return !!cssStr.split(" ").map((str) => str.replace(/\D/g, "")).filter((it) => Number(it)).length;
}

export { anyUndefined, callVoids, containsNumericValue, filterKeys, findLast, findLastIndex, getKeyboardFocusableElements, getScrollStatusVertical, neverDefault, printDevError, scan, stopPropagation, warnOnce, warnOnceWarnings, wrapEventHandlers };
